module.exports = __webpack_public_path__ + "assets/img/White.c785946c.svg";